export const HEAD_TITLE = 'DKTech'

